import graphql__b7dc6e8ce8fb8b59372d from "./__generated__/ContributionsMapContributionsMarkersFragment_participativeModule.graphql.js";import { graphql } from "react-relay";

// This fragment is used to refetch filtered data for contributions list with navigation
// to ensure that both the navigation cards and the list contributions details are
// actually reloaded when the connection is refetched after filters are changed
//
export const ContributionsMapContributionsMarkersFragment_participativeModule = graphql__b7dc6e8ce8fb8b59372d;
